export enum SessionFilterType {
    ALL = 'ALL',
    CURRENT_WEEK = 'CURRENT_WEEK',
    PREVIOUS_WEEK = 'PREVIOUS_WEEK',
    NEXT_WEEK = 'NEXT_WEEK',
    CURRENT_MONTH = 'CURRENT_MONTH',
    CUSTOM_DATE = 'CUSTOM_DATE'
}

export type CustomDateFilter = {
    type: SessionFilterType.CUSTOM_DATE;
    customStart: Date;
    customEnd: Date;
};

export type FilterType = SessionFilterType | CustomDateFilter;
